/* ==========================================================================
   Mondō London — navigation behaviours (master plan §3.2)
   Panels: mouse hover-intent (200ms) and touch disclosure.
   Mouse clicks and keyboard activation keep top-level links navigational.
   One panel at a time; Esc closes and returns focus; scrim below.
   Mobile overlay (scroll lock, focus trap-lite) and the search sheet with
   native /search/suggest.json predictive results. Safe DOM building only.
   ========================================================================== */
(function () {
  'use strict';
  var header = document.querySelector('[data-header]');
  if (!header) return;
  var scrim = header.querySelector('[data-scrim]');
  var items = Array.prototype.slice.call(header.querySelectorAll('[data-panel-item]'));
  var sheet = header.querySelector('[data-search-sheet]');
  var input = header.querySelector('[data-sheet-input]');
  var results = header.querySelector('[data-sheet-results]');
  var sheetStatus = header.querySelector('[data-sheet-status]');
  var expandedLinks = header.querySelector('[data-expanded-menu-links]');
  var mobileViewport = window.matchMedia('(max-width: 899px)');
  var hoverPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var openItem = null, intentTimer = null, scrimT = null, expandedLinksT = null;

  function showScrim() {
    if (!scrim) return;
    clearTimeout(scrimT); scrimT = null;
    scrim.hidden = false;
    // next frame so the opacity eases 0 → 1 instead of snapping
    requestAnimationFrame(function () { scrim.classList.add('is-in'); });
  }
  function hideScrim() {
    if (!scrim) return;
    scrim.classList.remove('is-in');
    clearTimeout(scrimT);
    scrimT = setTimeout(function () { scrim.hidden = true; scrimT = null; }, 560);
  }

  function syncHeaderExpanded() {
    var searchOpen = !!(sheet && !sheet.hidden);
    header.classList.toggle('is-expanded', !!openItem || searchOpen);
    var searchOpener = header.querySelector('[data-search-open]');
    if (searchOpener) searchOpener.setAttribute('aria-expanded', searchOpen ? 'true' : 'false');
  }

  function syncExpandedLinks(open, panel) {
    if (!expandedLinks) return;
    clearTimeout(expandedLinksT);
    expandedLinksT = null;

    if (open && panel) {
      panel.appendChild(expandedLinks);
      expandedLinks.hidden = false;
      expandedLinks.setAttribute('data-expanded-menu-open', '');
      return;
    }

    expandedLinks.removeAttribute('data-expanded-menu-open');
    expandedLinksT = setTimeout(function () {
      if (!openItem) {
        expandedLinks.hidden = true;
      }
      expandedLinksT = null;
    }, 560);
  }

  function setPanel(item, open) {
    var trig = item.querySelector('[data-panel-trigger]');
    var panel = item.querySelector('[data-panel]');
    trig.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel._hideT) { clearTimeout(panel._hideT); panel._hideT = null; }
    if (open) {
      panel.inert = false;
      panel.hidden = false;
      item.classList.add('is-open');
    } else {
      // drop is-open to start the fade-out; keep the panel in the DOM until the
      // transition finishes — display:none (via [hidden]) would cut it dead
      panel.inert = true;
      item.classList.remove('is-open');
      panel._hideT = setTimeout(function () {
        if (!item.classList.contains('is-open')) panel.hidden = true;
        panel._hideT = null;
      }, 560);
    }
  }
  function closeAll(returnFocus) {
    if (!openItem) { syncHeaderExpanded(); return; }
    var trig = openItem.querySelector('[data-panel-trigger]');
    setPanel(openItem, false);
    openItem = null;
    syncExpandedLinks(false);
    hideScrim();
    syncHeaderExpanded();
    if (returnFocus && trig) trig.focus();
  }
  function openPanel(item) {
    if (openItem === item) { syncHeaderExpanded(); return; }
    if (openItem) setPanel(openItem, false);
    setPanel(item, true);
    openItem = item;
    syncExpandedLinks(true, item.querySelector('[data-panel]'));
    // scrim offset follows the complete two-row header in base.css
    showScrim();
    syncHeaderExpanded();
  }

  items.forEach(function (item) {
    var trig = item.querySelector('[data-panel-trigger]');
    var activationPointer = '';
    item.addEventListener('pointerenter', function (e) {
      // Trackpads and mice report "mouse" here. Touch and pen pointer-enter
      // events must never pre-open a panel before their disclosure tap.
      if (e.pointerType !== 'mouse') return;
      clearTimeout(intentTimer);
      intentTimer = setTimeout(function () { openPanel(item); }, 200);
    });
    item.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      clearTimeout(intentTimer);
      intentTimer = setTimeout(function () { if (openItem === item) closeAll(false); }, 250);
    });
    trig.addEventListener('pointerdown', function (e) {
      activationPointer = e.pointerType || '';
      if (activationPointer === 'touch' || activationPointer === 'pen') {
        clearTimeout(intentTimer);
      }
    });
    trig.addEventListener('pointercancel', function () {
      activationPointer = '';
    });
    trig.addEventListener('click', function (e) {
      // The preceding pointerdown is the authoritative input. Some Safari
      // compatibility clicks identify themselves as mouse after a finger tap.
      var pointerType = activationPointer || e.pointerType || '';
      activationPointer = '';
      var touchActivation = pointerType === 'touch' || pointerType === 'pen';
      var keyboardActivation = e.detail === 0;
      var directLinkActivation = trig.tagName === 'A' && (
        keyboardActivation || (!touchActivation && (
          pointerType === 'mouse' || (!pointerType && hoverPointer.matches)
        ))
      );

      // A mouse/trackpad click is already paired with hover disclosure, while
      // Enter should preserve the native destination of a real link.
      if (directLinkActivation) {
        clearTimeout(intentTimer);
        return;
      }

      // Disclosure buttons keep their destination inside the open panel. Native
      // button activation handles mouse, touch, Enter and Space consistently.
      if (trig.tagName === 'BUTTON') {
        e.preventDefault();
        if (openItem === item) closeAll(false);
        else openPanel(item);
        return;
      }
      // Touch/pen (and legacy coarse-pointer clicks) disclose on first
      // activation; once visible, a second activation follows the real link.
      if (openItem !== item) { e.preventDefault(); openPanel(item); }
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAll(true); closeSheet(true); closeMobile(); }
  });
  if (scrim) scrim.addEventListener('click', function () { closeAll(false); });
  document.addEventListener('click', function (e) {
    if (openItem && !e.target.closest('[data-panel-item]') && !e.target.closest('[data-expanded-menu-links]')) closeAll(false);
  });

  window.addEventListener('resize', function () {
    if (mobileViewport.matches && openItem) closeAll(false);
  });

  /* ── mobile overlay ─────────────────────────────────────────────────── */
  var mobile = header.querySelector('[data-mobile]');
  var mobileOpener = header.querySelector('[data-menu-open]');
  function mobileFocusable() {
    return mobile
      ? Array.prototype.slice.call(mobile.querySelectorAll('a[href], button:not([disabled])'))
      : [];
  }
  function openMobile() {
    if (!mobile) return;
    closeAll(false);
    closeSheet(false);
    mobile.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    if (mobileOpener) mobileOpener.setAttribute('aria-expanded', 'true');
    var c = mobile.querySelector('[data-menu-close]');
    if (c) c.focus();
  }
  function closeMobile() {
    if (!mobile || mobile.hidden) return;
    mobile.hidden = true;
    document.documentElement.style.overflow = '';
    if (mobileOpener) {
      mobileOpener.setAttribute('aria-expanded', 'false');
      mobileOpener.focus();
    }
  }
  header.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) openMobile();
    if (e.target.closest('[data-menu-close]')) closeMobile();
  });
  if (mobile) {
    mobile.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusable = mobileFocusable();
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  /* ── search sheet ───────────────────────────────────────────────────── */
  var debounce = null, requestController = null, requestSerial = 0, optionSerial = 0;
  var approvedCollectionHandles = 'all|new-arrivals|archive|outerwear|tops|bottoms|dresses|footwear|bags|accessories|objects'.split('|');
  var controlledVendors = 'Comme des Garçons|Yohji Yamamoto|Issey Miyake|Rick Owens|Ann Demeulemeester|Maison Margiela|Jil Sander|Prada|Dries Van Noten|Céline|Chanel'.split('|');

  function shopRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function collectionSuggestionHandle(collection) {
    if (collection && collection.handle) return String(collection.handle).toLowerCase();
    var match = String((collection && collection.url) || '').match(/\/collections\/([^/?#]+)/);
    if (!match) return '';
    try {
      return decodeURIComponent(match[1]).toLowerCase();
    } catch (_) {
      return match[1].toLowerCase();
    }
  }

  function isApprovedCollectionSuggestion(collection) {
    return approvedCollectionHandles.indexOf(collectionSuggestionHandle(collection)) !== -1;
  }

  function searchKey(value) {
    var key = String(value || '').toLowerCase();
    if (key.normalize) key = key.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return key;
  }

  function matchingVendors(query) {
    var key = searchKey(query);
    if (!key) return [];
    return controlledVendors.filter(function (vendor) {
      return searchKey(vendor).indexOf(key) !== -1;
    });
  }

  function options() {
    return results ? Array.prototype.slice.call(results.querySelectorAll('[role="option"]')) : [];
  }

  function syncCombobox() {
    if (!input) return;
    input.setAttribute('aria-expanded', sheet && !sheet.hidden && options().length ? 'true' : 'false');
  }

  function setBusy(busy) {
    if (results) results.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function cancelSuggest() {
    requestSerial += 1;
    if (requestController) requestController.abort();
    requestController = null;
    setBusy(false);
  }

  function prepareOption(anchor) {
    optionSerial += 1;
    anchor.id = 'sheet-option-' + optionSerial;
    anchor.setAttribute('role', 'option');
    anchor.setAttribute('tabindex', '-1');
    anchor.setAttribute('aria-selected', 'false');
    return anchor;
  }

  function focusOption(index) {
    var list = options();
    if (!list.length) return;
    var next = (index + list.length) % list.length;
    list.forEach(function (option, i) {
      option.setAttribute('aria-selected', i === next ? 'true' : 'false');
    });
    list[next].focus();
  }

  function openSheet() {
    if (!sheet) return;
    closeAll(false);
    sheet.hidden = false;
    syncHeaderExpanded();
    syncCombobox();
    if (input) input.focus();
  }
  function closeSheet(returnFocus) {
    if (!sheet || sheet.hidden) { syncHeaderExpanded(); return; }
    clearTimeout(debounce);
    cancelSuggest();
    sheet.hidden = true;
    syncHeaderExpanded();
    syncCombobox();
    if (returnFocus) {
      var opener = header.querySelector('[data-search-open]');
      if (opener) opener.focus();
    }
  }
  header.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) openSheet();
  });
  document.addEventListener('click', function (e) {
    if (sheet && !sheet.hidden && !e.target.closest('[data-search-sheet]') && !e.target.closest('[data-search-open]')) closeSheet();
  });

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function suggestLabel(name, fallback) {
    return (results && results.getAttribute('data-l-' + name)) || fallback;
  }
  // empty/error messages live outside the listbox, in the role="status" sibling
  function setSheetStatus(message) {
    if (!sheetStatus) return;
    sheetStatus.textContent = message || '';
    sheetStatus.hidden = !message;
  }
  // a listbox may only own options and groups; the visible label is decorative,
  // the group's aria-label carries the name
  function suggestGroup(label) {
    var g = el('div', 'sr-group');
    g.setAttribute('role', 'group');
    g.setAttribute('aria-label', label);
    var p = el('p', 'sr-label', label);
    p.setAttribute('aria-hidden', 'true');
    g.appendChild(p);
    return g;
  }
  function renderSuggest(data, q) {
    if (!results) return;
    results.textContent = '';
    setSheetStatus('');
    var res = (data && data.resources && data.resources.results) || {};
    var products = res.products || [];
    var collections = (res.collections || []).filter(isApprovedCollectionSuggestion);
    var vendors = matchingVendors(q);
    if (products.length) {
      var pg = suggestGroup(suggestLabel('pieces', 'Pieces'));
      products.slice(0, 4).forEach(function (p) {
        var a = prepareOption(el('a', 'sr-row'));
        a.href = p.url;
        if (p.featured_image && p.featured_image.url) {
          var img = document.createElement('img');
          img.src = p.featured_image.url; img.alt = ''; img.width = 56; img.height = 70;
          a.appendChild(img);
        }
        a.appendChild(el('span', 'sr-title serif', p.title));
        a.appendChild(el('span', 'sr-price', p.available === false ? suggestLabel('unavailable', 'Unavailable') : (p.price ? '£' + p.price : '')));
        pg.appendChild(a);
      });
      results.appendChild(pg);
    }
    if (vendors.length || collections.length) {
      var cg = suggestGroup(suggestLabel('makers', 'Brands & categories'));
      var discoveryCount = 0;
      vendors.slice(0, 3).forEach(function (vendor) {
        var a = prepareOption(el('a', 'sr-row sr-row--maker'));
        a.href = shopRoot() + 'collections/all?filter.p.vendor=' + encodeURIComponent(vendor);
        a.appendChild(el('span', 'sr-title serif', vendor));
        cg.appendChild(a);
        discoveryCount += 1;
      });
      collections.slice(0, Math.max(0, 3 - discoveryCount)).forEach(function (c) {
        var a = prepareOption(el('a', 'sr-row sr-row--maker'));
        a.href = c.url;
        a.appendChild(el('span', 'sr-title serif', c.title));
        cg.appendChild(a);
      });
      results.appendChild(cg);
    }
    if (!products.length && !collections.length && !vendors.length) {
      setSheetStatus(suggestLabel('none', 'No suggestions here. Press Enter to search the catalogue.'));
    } else {
      var all = prepareOption(el('a', 'sr-all'));
      all.href = shopRoot() + 'search?q=' + encodeURIComponent(q) + '&type=product';
      var em = el('em', null, suggestLabel('all-results', 'All results for') + ' “' + q + '”');
      all.appendChild(em);
      results.appendChild(all);
    }
    syncCombobox();
  }

  function renderSuggestError() {
    if (!results) return;
    results.textContent = '';
    setSheetStatus(suggestLabel('error', 'Search is unavailable. Press Enter to continue.'));
    syncCombobox();
  }

  if (results) {
    if (!results.id) results.id = 'sheet-results';
    results.setAttribute('role', 'listbox');
    results.setAttribute('aria-busy', 'false');
    results.addEventListener('keydown', function (e) {
      var option = e.target.closest ? e.target.closest('[role="option"]') : null;
      if (!option) return;
      var list = options();
      var index = list.indexOf(option);
      if (e.key === 'ArrowDown') { e.preventDefault(); focusOption(index + 1); }
      if (e.key === 'ArrowUp') { e.preventDefault(); focusOption(index - 1); }
    });
  }
  if (input) {
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    if (results) input.setAttribute('aria-controls', results.id);
    input.addEventListener('keydown', function (e) {
      var list = options();
      if (!list.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); focusOption(0); }
      if (e.key === 'ArrowUp') { e.preventDefault(); focusOption(list.length - 1); }
    });
    input.addEventListener('input', function () {
      clearTimeout(debounce);
      cancelSuggest();
      var q = input.value.trim();
      if (results) results.textContent = '';
      setSheetStatus('');
      syncCombobox();
      if (q.length < 2) return;
      debounce = setTimeout(function () {
        var serial = ++requestSerial;
        requestController = typeof AbortController !== 'undefined' ? new AbortController() : null;
        var fetchOptions = requestController ? { signal: requestController.signal } : {};
        setBusy(true);
        fetch(shopRoot() + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=4', fetchOptions)
          .then(function (r) {
            if (!r.ok) throw new Error('Predictive search failed');
            return r.json();
          })
          .then(function (d) {
            if (serial === requestSerial) renderSuggest(d, q);
          })
          .catch(function (err) {
            if (serial !== requestSerial || (err && err.name === 'AbortError')) return;
            renderSuggestError();
          })
          .then(function () {
            if (serial !== requestSerial) return;
            requestController = null;
            setBusy(false);
          });
      }, 250);
    });
  }
})();
